// Stimulus Form Controller

import { Controller } from '@hotwired/stimulus'
import debounce from 'lodash/debounce'
import throttle from 'lodash/throttle'

export default class extends Controller {
  static values = {
    debounceTime: { type: Number, default: 300 },
    throttleTime: { type: Number, default: 500 }
  }

  initialize() {
   // Bind and wrap the submit method using debounce and throttle from lodash
    this.debouncedSubmit = debounce(this.submit.bind(this), this.debounceTimeValue)
    this.throttledSubmit = throttle(this.submit.bind(this), this.throttleTimeValue, {
      trailing: true,  // Ensures a final call happens at the end of the interval
      leading: false,  // Only call at the end, not the start
    })
  }

  submit(_event) {
    // Assuming this controller is connected directly to the <form> element
    // and "this.element" is the form
    this.element.requestSubmit()
  }
}
